export const FLUID_TYPOLOGIES = "FLUID_TYPOLOGIES";
export const FLUID_LIST = "FLUID_LIST";
export const REFRIGERANT_LIST = "REFRIGERANT_LIST";
